import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUTS, RISQUES } from "@/lib/dossiers";

export const EMPTY_FILTERS = { q: "", statut: "tous", risque: "tous" };

export function applyFilters(dossiers, f) {
    const q = f.q.trim().toLowerCase();
    return dossiers.filter((d) => {
        if (f.statut !== "tous" && d.statut_dossier !== f.statut) return false;
        if (f.risque !== "tous" && (d.niveau_risque || "Non évalué") !== f.risque) return false;
        if (!q) return true;
        const hay = [d.nom_mission, d.entreprises?.nom_entreprise, d.entreprises?.siren, d.users_clients?.prenom_nom, d.users_clients?.email, d.type_dossier]
            .filter(Boolean).join(" ").toLowerCase();
        return hay.includes(q);
    });
}

export default function DossierFilters({ filters, onChange }) {
    const set = (k) => (v) => onChange({ ...filters, [k]: v });
    const active = filters.q || filters.statut !== "tous" || filters.risque !== "tous";
    return (
        <div data-testid="dossier-filters" className="flex flex-wrap items-center gap-3">
            <div className="relative flex-1 min-w-[240px]">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" strokeWidth={1.75} />
                <Input
                    data-testid="dossier-search-input"
                    value={filters.q}
                    onChange={(e) => set("q")(e.target.value)}
                    placeholder="Rechercher une entreprise, un SIREN, un client…"
                    className="h-10 pl-9 bg-card"
                />
            </div>
            <Select value={filters.statut} onValueChange={set("statut")}>
                <SelectTrigger data-testid="filter-statut" className="h-10 w-[220px] bg-card"><SelectValue /></SelectTrigger>
                <SelectContent>
                    <SelectItem value="tous" data-testid="filter-statut-tous">Tous les statuts</SelectItem>
                    {Object.entries(STATUTS).map(([k, l]) => <SelectItem key={k} value={k} data-testid={`filter-statut-${k}`}>{l}</SelectItem>)}
                </SelectContent>
            </Select>
            <Select value={filters.risque} onValueChange={set("risque")}>
                <SelectTrigger data-testid="filter-risque" className="h-10 w-[190px] bg-card"><SelectValue /></SelectTrigger>
                <SelectContent>
                    <SelectItem value="tous" data-testid="filter-risque-tous">Tous les risques</SelectItem>
                    {RISQUES.map((r) => <SelectItem key={r} value={r} data-testid={`filter-risque-${r}`}>{r}</SelectItem>)}
                </SelectContent>
            </Select>
            {active && (
                <button type="button" data-testid="filters-reset" onClick={() => onChange(EMPTY_FILTERS)} className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground">
                    <X className="h-3.5 w-3.5" /> Réinitialiser
                </button>
            )}
        </div>
    );
}
